/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2022-07-22 14:50:13
 * @LastEditors: yanghui
 * @LastEditTime: 2022-08-17 10:11:00
 */
import axios from "../../utils/axios";

// 客户邮箱查询数据
export function isUserEmail(query) {
  return axios({
    url: "otherorder/queryUser",
    method: "get",
    params: query
  });
}

// 币制
export function getCoinDict(query) {
  return axios({
    url: "otherorder/getCoinDict",
    method: "get",
    params: query
  });
}

// 保存
export function save(data) {
  return axios({
    url: "otherorder/save",
    method: "post",
    data: data
  });
}

// 提交
export function submit(data) {
  return axios({
    url: "otherorder/submit",
    method: "post",
    data: data
  });
}

// 查看-点击修改获取详情
export function getInfoApi(query) {
  return axios({
    url: "otherorder/getInfo",
    method: "get",
    params: query
  });
}

// 计量单位
export function getUnitApi(query) {
  return axios({
    url: "otherorder/getUnit",
    method: "get",
    params: query
  });
}

